/** Pictos mono blancs des actions commerciales (Devis / Réserver / Vendre) — à poser sur fond plein. */
const Svg = ({ size = 18, children, ...rest }) => (
  <svg viewBox="0 0 40 40" width={size} height={size} aria-hidden="true" focusable="false" style={{ flexShrink: 0, display: "inline-block" }} {...rest}>{children}</svg>
);

export const ActDevis = (p) => (
  <Svg data-testid="act-icon-devis" {...p}><path d="M10 5H24L31 12V34A1.5 1.5 0 0 1 29.5 35.5H10A1.5 1.5 0 0 1 8.5 34V6.5A1.5 1.5 0 0 1 10 5Z" fill="none" stroke="#fff" strokeWidth="2.5" /><path d="M24 5V12H31" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinejoin="round" /><path d="M13 19H25M13 24H25M13 29H20" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" /></Svg>
);
export const ActReserver = (p) => (
  <Svg data-testid="act-icon-reserver" {...p}><path d="M11 5H29A2 2 0 0 1 31 7V35L20 28L9 35V7A2 2 0 0 1 11 5Z" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinejoin="round" /></Svg>
);
export const ActVendre = (p) => (
  <Svg data-testid="act-icon-vendre" {...p}><circle cx="14" cy="20" r="7.5" fill="none" stroke="#fff" strokeWidth="2.5" /><path d="M20 20H34M30 20V26M34 20V27" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" /></Svg>
);

export const ACTION_ICONS = { devis: ActDevis, reserve: ActReserver, sell: ActVendre };
export const ACTION_COLORS = { devis: "#378ADD", reserve: "#E0822E", sell: "#2A9A7A" };
